// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1_xVa","cls2":"UserTooltip-cls2_Ox7 UserTooltip-cls1_xVa"};